'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCalendarDay, iconCalendarDayTag } from '@ni/nimble-components/dist/esm/icons/calendar-day';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCalendarDay };
export { iconCalendarDayTag };
export const NimbleIconCalendarDay = wrap(IconCalendarDay);